// Styled
import { styled } from '@mui/material/styles'
import { Typography, ListItemButton } from '@mui/material'
// Common
import { Switch } from '$common/switch'

const Container = styled(ListItemButton)`
  height: 50px;

  box-sizing: border-box;
  padding: 0 20px 0 20px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

interface Props {
  label: string
  checked: boolean
  disabled?: boolean
  onChange: () => unknown
}

export function LabeledSwitch({ label, checked, disabled, onChange }: Props) {
  return (
    <Container onClick={onChange} disabled={disabled}>
      <Typography variant="body2">{label}</Typography>
      <Switch checked={!!checked} disabled={disabled} />
    </Container>
  )
}

LabeledSwitch.defaultProps = {
  disabled: false,
}
